import React from 'react';
import Storage from '../common/Storage';
import axios from 'axios';
import Constants from '../common/Constants';
import SimpleModal from '../common/SimpleModal';

import FolderTree, { testData } from 'react-folder-tree';

class AdminReportFolderTree extends React.Component {
    constructor(props) {
        super(props);

        let user = Storage.getItem('CurrentUser');

        this.state = {
            user,
            folderList: [],
            treeData: null,
            newId: 0,
            savedModalShow: false
        };
    }

    /**
     * Convert the flat folder list (with fullPath strings) into a nested tree
     * structure the FolderTree component expects:
     * { name: "Root", children: [ { name: "Folder1", children: [...] }, ... ] }
     *
     * Each node will also include the original reportFolderId when available
     * as `reportFolderId` on the leaf node that corresponds to the folder entry.
     */
    TreeConvert = (flatList) => {
        const root = { name: 'All Folders', children: [] };

        if (!Array.isArray(flatList) || flatList.length === 0) {
            return root;
        }

        // Ensure deterministic order: already sorted upstream, but keep stable insert order.
        flatList.forEach(item => {
            // Normalize path and split into segments
            const fullPath = (item.fullPath || '').trim();
            const segments = fullPath.split('/').filter(s => s.length > 0);

            // If path is empty, create a top-level unnamed node or skip; we'll create a "New" node
            if (segments.length === 0) {
                // add a placeholder top-level node
                const placeholder = { name: item.fullPath || '(new)', reportFolderId: item.reportFolderId };
                root.children.push(placeholder);
                return;
            }

            // Walk/create nodes for each segment
            let current = root;
            for (let i = 0; i < segments.length; i++) {
                const seg = segments[i];
                // find an existing child with this name
                let child = (current.children || []).find(c => c.name === seg);
                if (!child) {
                    child = { name: seg, children: [] };
                    current.children = current.children || [];
                    current.children.push(child);
                }

                // If this is the last segment, attach the reportFolderId so leaf nodes map back to server items
                if (i === segments.length - 1 && item.reportFolderId !== undefined && item.reportFolderId !== null) {
                    child.reportFolderId = item.reportFolderId;
                }

                current = child;
            }
        });

        return root;
    }

        loadFolderList = () => {
        axios.get(Constants.URL_API + 'ReportFolder/GetAll?id=' + this.props.residentialId, { headers: Storage.getAuth() })
            .then(res => {
                let folderList = res.data;
                folderList.sort((a, b) => (a.fullPath > b.fullPath ? 1 : -1));
                const treeData = this.TreeConvert(folderList);
                this.setState({ folderList, treeData });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({ apiCode: error.response.status });
                } else if (error.request) {
                    this.setState({ apiCode: 0 });
                } else {
                    this.setState({ apiCode: 0 });
                    console.log('Error', error.message);
                }
            });
    }
    
    reloadData = () => {
        this.loadFolderList();
    }

    componentDidMount() {
        this.reloadData();
        //if (this.props.setSave) { this.props.setSave(this.Save); }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.residentialId !== this.props.residentialId) {
            this.reloadData();
        }
    }

    DeleteItem = (r) => {
        this.PropertyUpdate(r, { rowStatus: Constants.STATUS_DELETE });
    }

    Add = () => {
        let folderList = this.state.folderList;
        let newId = this.state.newId - 1;

        folderList.unshift({ reportFolderId: newId, fullPath: "", rowStatus: Constants.STATUS_NEW });
        this.setState({ folderList, newId }, () => {
            // update treeData after adding a new item
            const treeData = this.TreeConvert(this.state.folderList);
            this.setState({ treeData });
        });
    }
    
    PropertyUpdate = (r, newObj) => {
        let folderList = this.state.folderList;
        let folder = folderList.find((i) => i.reportFolderId === r.reportFolderId);
        Object.assign(folder, { rowStatus: Constants.STATUS_EDIT }, newObj);
        this.setState(folderList);
    }
    
    ChangeName = (r, e) => {
        this.PropertyUpdate(r, { fullPath: e.target.value });
    }

    /*ChangePublic = (r, e) => {
        this.PropertyUpdate(r, { isPublic: e.target.checked });
    }*/
    
    Save = () => {
        this.Create();
        this.Update();
        this.Delete();
        this.setState({ savedModalShow: true }, () => {
            // reload and reconvert after save to reflect server state
            this.reloadData();
        });
    }

    CleanStatus = () => {
        let folderList = this.state.folderList;
        folderList.forEach(u => u.rowStatus = null);
        this.setState({ folderList });
    }

    Create = () => {
        let list = this.state.folderList.filter(u => u.reportFolderId < 0 && u.rowStatus == Constants.STATUS_EDIT);
        this.SaveAPI("CreateMultiple", "post", list);
    }
    
    Update = () => {
        let list = this.state.folderList.filter(u => u.reportFolderId > 0 && u.rowStatus == Constants.STATUS_EDIT);
        this.SaveAPI("UpdateMultiple", "put", list);
    }

    Delete = () => {
        let list = this.state.folderList.filter(u => u.reportFolderId > 0 && u.rowStatus == Constants.STATUS_DELETE);
        let ids = list.map(u => u.reportFolderId);
        this.SaveAPI("DeleteMultiple", "delete", ids);
    }
    
    SaveAPI = (action, method, data) => {
        if (data.length == 0) { return; }
        axios(Constants.URL_API + 'ReportFolder/' + action, { method, data, headers: Storage.getAuth() })
            .then(res => {
                //this.setState({ userList: res.data });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({ apiCode: error.response.status });
                } else if (error.request) {
                    this.setState({ apiCode: 0 });
                } else {
                    this.setState({ apiCode: 0 });
                    console.log('Error', error.message);
                }
            });
    }
    
    render() {
        const data = this.state.treeData || testData;
        return (
            <FolderTree
                data={data} // converted tree data
                onChange={this.onTreeStateChange}
            />
        );
    }
}

export default AdminReportFolderTree;